import { type Theme } from "@mui/material";

export function getFilterSliderStyles(theme: Theme) {
  return {
    marginX: 2,
    width: "auto",
    height: "0.5rem",
    padding: "1rem",
    marginBottom: "2rem",
    ".MuiSlider-markLabel": {
      marginTop: "0.3rem",
    },
    "& .MuiSlider-rail": {
      height: "0.5rem",
      color: theme.palette.background?.primary,
    },
    "& .MuiSlider-thumb": {
      backgroundColor: theme.palette.background.tertiary,
      border: `1px solid ${theme.palette.primary?.main}`,
      height: "1.5rem",
      width: "1.5rem",
      backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
        `<svg xmlns='http://www.w3.org/2000/svg' width='8.5' height='10'>
                 <rect x='0' y='1' width='1' height='8' fill='${theme.palette.primary?.main}'/>
                 <rect x='3.5' y='0' width='1' height='12' fill='${theme.palette.primary?.main}'/>
                 <rect x='7' y='1' width='1' height='8' fill='${theme.palette.primary?.main}'/>
               </svg>`
      )}")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      "&:hover, &.Mui-focusVisible": {
        boxShadow: `0px 0px 0px 1px ${theme.palette.primary?.main}`,
      },
      "&.Mui-active": {
        boxShadow: `0px 0px 0px 2px ${theme.palette.primary?.main}`,
      },
    },
  };
}
